








































































import ApplicationCard from "@/components/global/ApplicationCard.vue";
import { DashboardState } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import router from "@/router";

@Component({
  name: "RateQueue",
  components: {
    ApplicationCard
  }
})
export default class RateQueue extends Vue {
  // ===== Store ===== //
  @State("dashboard") public dashboard!: DashboardState;
  // ===== Methods ===== //
  public viewRateQueue() {
    router.push({ name: "rateQueue" });
  }
  public updateMessage(notification: { facility_unit_type: { width: number; length: number; current_rate: number }; new_price: number }) {
    const width = notification.facility_unit_type.width;
    const length = notification.facility_unit_type.length;
    const currentPrice = notification.facility_unit_type.current_rate;
    const newPrice = notification.new_price;
    return `Updated ${width}' x ${length}' rates from $${currentPrice} to $${newPrice}`;
  }
}
